module.exports = __webpack_public_path__ + "img/Lisa_Chris_O_2.8a2d1f9f.jpg";